import { GQLAPIContextType } from 'types/common.types';
import { createGQLDataContext } from 'utils/createDataContext';
import { StaticGroup, DynamicGroup } from 'types/graphql';
import { FC, useContext, useMemo } from 'react';
import { useSSFBehaviors } from 'hooks';
import { fetchGroupConfig } from 'pages/Settings/modals/GroupsModal/GroupsModal.constants';
import { useGroupsDetailsModalUIContext } from 'pages/Settings/modals/GroupsModal/GroupsModal.ui.context';

export const GroupsModalDataContext =
  createGQLDataContext<GQLAPIContextType<StaticGroup | DynamicGroup>>();

export const GroupsModalDataProvider: FC = ({ children }) => {
  const { groupId } = useGroupsDetailsModalUIContext();

  const [, { data, fetch, isLoading, loadMore, ...restQuery }] = useSSFBehaviors(
    fetchGroupConfig(groupId),
  );
  if (
    data?.__typename === 'StaticGroup' &&
    !isLoading &&
    data?.groupJanes?.pageInfo?.hasNextPage &&
    loadMore
  ) {
    loadMore();
  }

  const contextValues = useMemo(() => {
    return {
      data,
      hasNextPage:
        data?.__typename === 'StaticGroup' &&
        data?.groupJanes &&
        data.groupJanes?.pageInfo?.hasNextPage
          ? data?.groupJanes && data.groupJanes?.pageInfo?.hasNextPage
          : false,
      fetch,
      ...restQuery,
    };
  }, [data, fetch, restQuery]);

  return (
    <GroupsModalDataContext.Provider value={contextValues}>
      {children}
    </GroupsModalDataContext.Provider>
  );
};

export const GroupsModalEmptyDataProvider: FC = ({ children }) => {
  return <GroupsModalDataContext.Provider value={{}}>{children} </GroupsModalDataContext.Provider>;
};

export const useGroupsModalDataContext = (): GQLAPIContextType<StaticGroup | DynamicGroup> =>
  useContext(GroupsModalDataContext);
